export const COURSES = [
  {
    key: "Nursing Algebra",
    index: "01",
    tag: "Math for Healthcare",
    image:
      "https://images.unsplash.com/photo-1584982751601-97dcc096659c?auto=format&fit=crop&w=1600&q=80",
    blurb:
      "Nursing Algebra provides the mathematical foundation needed for safe and effective patient care. It helps nursing students develop the skills to calculate medication dosages, IV flow rates, solution concentrations, and dosage conversions with confidence and accuracy. By connecting algebraic concepts to real-world healthcare situations, students build critical thinking and problem-solving abilities that are essential in clinical practice. A strong understanding of nursing algebra not only improves academic success but also promotes patient safety and prepares future nurses for the mathematical demands of today's healthcare environment.",
  },
  {
    key: "Books",
    index: "02",
    tag: "Books for Personal Growth",
    image:
      "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?auto=format&fit=crop&w=1600&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1512820790803-83ca734da794?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1519682337058-a94d519337bc?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1507842217343-583bb7270b66?auto=format&fit=crop&w=1600&q=80",
    ],
    blurb:
      "My books are designed to educate, inspire, and empower readers through practical knowledge and real-world experience. Covering topics such as mathematics, nursing algebra, leadership, artificial intelligence, personal growth, military service, and human connection, each book is written to help readers build confidence, develop new skills, and achieve their goals. Whether you are a student, educator, healthcare professional, veteran, or lifelong learner, my books provide valuable insights and practical strategies for personal and professional success.",
  },
  {
    key: "Arts",
    index: "03",
    tag: "Visual Studio",
    image:
      "https://images.unsplash.com/photo-1605721911519-3dfeb3be25e7?auto=format&fit=crop&w=1600&q=80",
    video: "/art.mp4",
    blurb:
      "My artwork reflects creativity, imagination, and the beauty found in everyday life. Through digital art and original designs, I create images that inspire, tell stories, and spark meaningful conversations. From nature and landscapes to inspirational and educational themes, each piece is created with the goal of connecting with others and celebrating creativity. I invite you to explore my collection and discover artwork that informs, inspires, and brings joy.",
  },
  {
    key: "Leadership",
    index: "04",
    tag: "People & Strategy",
    image:
      "https://images.unsplash.com/photo-1544531586-fde5298cdd40?auto=format&fit=crop&w=1600&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1544531586-fde5298cdd40?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1515187029135-18ee286d815b?auto=format&fit=crop&w=1600&q=80",
      "https://images.unsplash.com/photo-1560439514-4e9645039924?auto=format&fit=crop&w=1600&q=80",
    ],
    blurb:
      "Our leadership courses are designed to help professionals, educators, students, and emerging leaders build the skills needed to lead with confidence and integrity. Through practical strategies, real-world examples, and interactive learning, you'll strengthen your communication, decision-making, problem-solving, and team-building abilities. Whether you're preparing for a leadership role or looking to enhance your current skills, these courses provide the knowledge and tools to help you succeed in today's changing workplace.",
  },
];

export const PRICING = {
  "Nursing Algebra": { price: "$199", note: "Full 6-week online course" },
  "Leadership": { price: "$149", note: "4-week online course" },
  "Math Tutoring": { price: "$50", note: "Per 1-hour online session" },
  "Math Tutoring Bundle": { price: "$225", note: "5 sessions — save $25" },
};
